var map = {
	"./de/world.json": 63966,
	"./en/world.json": 62730,
	"./es/world.json": 67537,
	"./fr/world.json": 56057,
	"./it/world.json": 99708,
	"./nl/world.json": 61163,
	"./pt/world.json": 52309
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 91148;
module.exports = webpackAsyncContext;